module.exports = __webpack_public_path__ + "img/icon-3.00bfde69.svg";